<template>
  <ul class="PageNav">
    <template v-if="!isMobile && !hash">
      <li v-for="(link, index) in data" :key="index"><router-link :to="link.to" v-html="link.label"></router-link></li>

      <transition name="pagenav" appear>
        <ul class="PageNav PageNav_sticky" v-show="isSticky">
          <li v-for="(link, index) in data" :key="index"><router-link :to="link.to" v-html="link.label"></router-link></li>
        </ul>
      </transition>
    </template>

    <template v-else-if="!isMobile && hash">
      <li v-for="(link, index) in data" :key="index"><a v-scroll-to="'#' + link.to.split('#')[1]" v-html="link.label"></a></li>

      <transition name="pagenav" appear>
        <ul class="PageNav PageNav_sticky" v-show="isSticky">
          <li v-for="(link, index) in data" :key="index"><a v-scroll-to="'#' + link.to.split('#')[1]" v-html="link.label" :class="{ 'router-link-exact-active': link.to == selected }"></a></li>
        </ul>
      </transition>
    </template>

    <template v-else>
      <v-select v-if="!$tools.isTouchDevice()" v-model="selected" :dir="'auto'" :clearable="false" :searchable="false" :options="data" label="label" placeholder="Séléctionnez une entrée">
        <template slot="option" slot-scope="option">
          <router-link :to="option.to" v-html="option.label"></router-link>
        </template>
      </v-select>
      <select v-model="selected" class="PageNav_select" v-else @change="onChange">
        <option disabled hidden value="">Sélectionnez une entrée</option>
        <option v-for="(el, index) in data" :key="index" :value="el.to">{{el.label }}</option>
      </select>
      <i class="far fa-angle-down" v-if="$tools.isTouchDevice()"></i>

      <transition name="pagenav" appear>
        <div class="PageNav PageNav_sticky" v-show="isSticky">
          <v-select v-if="!$tools.isTouchDevice()" v-model="selected" :dir="'auto'" :clearable="false" :searchable="false" :options="data" label="label" placeholder="Séléctionnez une entrée">
            <template slot="option" slot-scope="option">
              <router-link :to="option.to" v-html="option.label"></router-link>
            </template>
          </v-select>
          <select v-model="selected" class="PageNav_select" v-else @change="onChange">
            <option disabled hidden value="">Sélectionnez une entrée</option>
            <option v-for="(el, index) in data" :key="index" :value="el.to">{{ el.label }}</option>
          </select>
          <i class="far fa-angle-down" v-if="$tools.isTouchDevice()"></i>
        </div>
      </transition>
    </template>
  </ul>
</template>

<script>
  export default {
    name: "PageNav",
    props: [ 'data', "hash" ],
    data() {
      return {
        isSticky: false,
        isMobile: false,
        selected: null,
        lastWidth: 0
      }
    },
    watch: {
      $route()
      {
        console.log('$rpite')
        this.onResize()
      }
    },
    methods: {
      onScroll()
      {
        let rect = this.$el.getBoundingClientRect()

        if(rect.top < 0)
        {
          this.isSticky = true
        }else
        {
          this.isSticky = false
        }
      },
      refresh(to)
      {
        this.onResize(to)
      },
      onChange()
      {
        this.$router.push(this.selected)
      },
      onResize(to)
      {
        let test = to && to.type ? this.$route.path : to || this.$route.path

        console.log(test)

        if(window.innerWidth <= 960)
        {
          this.isMobile = true
        }else{
          this.isMobile = false
        }

        if(window.innerWidth === this.lastWidth && !to) return

        this.lastWidth = window.innerWidth

        this.selected = this.data.find(element => element.to === test );

        if(this.selected && this.$tools.isTouchDevice() && this.isMobile)
        {
          console.log('1')
          this.selected = this.selected.to
        }
        else if(this.selected && !this.$tools.isTouchDevice() && this.isMobile)
        {
          console.log('2')
          this.selected = this.selected.label
        }
        else if(this.selected && !this.isMobile)
        {
          console.log('3')
          this.selected = this.selected.to
        }

        if(!this.selected)
          this.selected = ""
      }
    },
    updated()
    {
      console.log('update')
    },
    mounted()
    {
      window.addEventListener('scroll', this.onScroll)

      window.addEventListener('resize', this.onResize)
      this.onResize()

      this.onScroll()
    },
    beforeDestroy()
    {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onResize)
    }
  }
</script>

<style lang="stylus">
.PageNav

  display flex
  align-items stretch
  flex-direction row
  justify-content: center
  margin 60px auto 0px auto
  max-width 1200px
  text-transform uppercase
  width 100%
  border-top 1px solid rgba(255,255,255,0.1)
  box-sizing: border-box;
  list-style none
  padding 0px
  font-size 14px
  font-family $f-title
  font-weight 400

  position relative

  @media $medium

    height 55px
    max-width none
    padding 0px 0px
    align-items center
    justify-content flex-start

    .v-select

      width 100%
      color white
      margin auto auto

      svg

        fill white

      a

        color $blue

        &:before

          content none

    .vs__dropdown-toggle

      border 0px

    .vs__actions

      padding 0px

    .vs__dropdown-option--highlight

      background-color $n2

    .vs__selected, .PageNav_select

      color white
      font-weight 400
      text-transform uppercase
      letter-spacing: 0;
      white-space nowrap
      margin 0px
      position absolute
      top 50%
      left 0px
      transform translateY(-50%)
      
    .vs__dropdown-toggle

      padding 0px

    .vs__selected, .vs__search, .vs__dropdown-option, input, input::placeholder, .PageNav_select, select::placeholder

      font-family $f-title
      color white
      font-weight 400
      text-transform uppercase
      font-size: 12px;
      letter-spacing: 0;
      line-height: 14px;
      margin 0px!important
      padding 0px!important

    .vs__dropdown-option

      padding 0px 25px!important

    i

      margin-left auto
      margin-right 0px

  li

    padding 0px 15px
    position relative

    a

      color inherit 
      padding 20px 0px 25px 0px
      display block
      text-decoration none
      opacity 0.7
      cursor pointer
      position relative
      transition opacity 0.6s $ease

      &:before

        content ''
        position absolute
        top -1px
        left 50%
        transform translateX(-50%)
        width 0%
        background-color white
        height 2px
        transition 0.6s $ease

      &:after

        content ''
        position absolute
        top 100%
        left 50%
        transform translateX(-50%) scale(0)
        width 0%
        transform-origin center top
        transition 0.6s $ease
        width: 0; 
        height: 0; 
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 10px solid $blue;

        @media $medium

          content none

      &.router-link-exact-active

        opacity 1

        &:before

          width 100%

        &:after

          transform translateX(-50%) scale(1)

  .PageNav_select

    width 100%
    box-sizing border-box
    appearance none
    border 0px
    background-color transparent
    
  &_sticky

    position fixed!important
    top 0px
    z-index 10
    left 0px
    margin-top 0px!important
    width 100vw!important
    max-width none!important
    border-top 0px
    border-bottom 1px solid rgba(31,39,109,0.1)
    background-color white

    .vs__selected, .vs__search, .vs__dropdown-option, input, input::placeholder, .PageNav_select, select::placeholder

      color $blue!important

    .PageNav_select

      padding 0px 25px!important

    svg, i

      fill $blue!important
      color $blue!important

    @media $medium

      top 60px
      height 50px
      padding 0px 25px
      box-sizing border-box

    li

      a

        color $blue

        &:after

          content none

        &:before

          background-color $blue
          bottom -1px
          top auto

.pagenav-enter-active, .pagenav-leave-active

  transition transform 0.6s $ease

.pagenav-enter, .pagenav-leave-to

  transform translateY(-100%)

</style>